export const ENGLISH_LANGUAGE = {
  languageCode: 'en',
  direction: 'LTR',
};

function hasLanguageCode(language) {
  return language && language.languageCode && language.languageCode !== 'undefined';
}

export function resolveEffectiveLanguage(userData, tenantSetting) {
  const preferredLanguage = hasLanguageCode(userData && userData.preferredLanguage)
    ? userData.preferredLanguage
    : undefined;
  const tenantLanguage = hasLanguageCode(tenantSetting && tenantSetting.systemDefaultLanguage)
    ? tenantSetting.systemDefaultLanguage
    : undefined;
  const language = preferredLanguage || tenantLanguage || ENGLISH_LANGUAGE;

  return {
    languageCode: language.languageCode || ENGLISH_LANGUAGE.languageCode,
    direction: language.direction || ENGLISH_LANGUAGE.direction,
  };
}
